import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ScreenerResultsCtx } from 'domains/signup/screener/Components/ScreenerResultsSummary/context';
import { Heading, Paragraph } from 'components/Typography';

import stairsImg from 'assets/images/screener/stairs-mascot.png';
import { Button } from 'components/Button';

export const ScreenerResultsNextStepsSection: React.FC = () => {
  const {
    onProceedToSchedule,
    results: { targetPatient },
  } = useContext(ScreenerResultsCtx);
  const { t } = useTranslation();

  return (
    <section className="flex flex-col gap-40">
      <Heading level="h2">{t(`screener.results.nextSteps.title.${targetPatient}`)}</Heading>

      <img alt="" src={stairsImg} className="max-w-[480px] w-full self-center" />

      <div>
        <Heading level="h5" useDefaultMargins>
          {t(`screener.results.nextSteps.subTitle.${targetPatient}`)}
        </Heading>
        <Paragraph>{t(`screener.results.nextSteps.text.${targetPatient}`)}</Paragraph>
      </div>

      <Button size="lg" onClick={onProceedToSchedule} className="sm-d:w-full w-max">
        {t('screener.results.nextSteps.scheduleBtn')}
      </Button>
    </section>
  );
};
